import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import {
  useEditDriverPumpAdjustmentsMutation,
  useLazyGetDriverPumpAdjustmentsQuery,
} from 'bus/driverPumpAdjustments/servisec';
import { DriverPumpAdjustmentsItem } from 'bus/driverPumpAdjustments/types';

import { DriverSalaryAdjustmentsForm } from '../../components';

type Props = {
  onRefresh: () => void;
  id: number;
  type: 'driver' | 'mixer' | 'employee' | 'pump';
};

const DRIVER_SALARY_ADJUSTMENTS_CREATE: DriverPumpAdjustmentsItem = {
  id: null,
  date: '',
  driverId: null,
  comment: '',
};

export const EditDriverSalaryAdjustmentsModal: FC<Props> = ({ onRefresh, id, type }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<DriverPumpAdjustmentsItem>(DRIVER_SALARY_ADJUSTMENTS_CREATE);

  const [getDriverSalaryAdjustmentsDetail] = useLazyGetDriverPumpAdjustmentsQuery();
  const [editDriverSalaryAdjustments] = useEditDriverPumpAdjustmentsMutation();

  const getDriverDetail = useCallback(async () => {
    getDriverSalaryAdjustmentsDetail({ id })
      .unwrap()
      .then((data) => {
        if (isSuccess(data)) {
          setForm(data);
        }
      });
  }, [getDriverSalaryAdjustmentsDetail, id]);

  useEffect(() => {
    getDriverDetail();
  }, [getDriverDetail]);

  const handleChange = (
    name: keyof DriverPumpAdjustmentsItem,
    value: DriverPumpAdjustmentsItem[keyof DriverPumpAdjustmentsItem],
  ) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    const updateData: DriverPumpAdjustmentsItem = {
      ...form,
      id,
    };

    editDriverSalaryAdjustments(updateData).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Корректировка успешно изменена', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Редактирование корректировки"
      visible
      isLoadingSubmit={false}
      width={500}
      height="auto"
      textConfirm="Сохранить"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <DriverSalaryAdjustmentsForm form={form} onChange={handleChange} type={type} />
    </ModalForm>
  );
};
